import React from 'react';
import { FallbackCard } from '../Elements/Card/FallbackCard';

interface NoAccessViewProps {
  title?: string;
  description?: string;
}

export const NoAccessView = ({
  title = 'No access',
  description = 'You do not have the permissions to view this page. ',
}: NoAccessViewProps) => {
  return (
    <div className="grid place-items-center h-full w-full max-w-3xl mx-auto">
      <FallbackCard title={title} description={description} />
    </div>
  );
};
